import * as types from './constants';
import {buildFormData} from "~/utils/formdata";

export const updateDocsTemplate = (documentId, data) => ({
    types: [
        types.UPDATE_DOCS_TEMPLATE_REQUEST,
        types.UPDATE_DOCS_TEMPLATE_SUCCESS,
        types.UPDATE_DOCS_TEMPLATE_FAILURE,
    ],
    promise: api => {
        let form = new FormData();
        buildFormData(form, data);
        return api({
            url: `/api/v1/modules/document-templates/document/${documentId ? 'update/' + documentId : 'create'}`,
            method: 'POST',
            body: form,
        });
    }
});

export const deleteTemplate = (documentId) => ({
    types: [
        types.DELETE_DOCS_TEMPLATE_REQUEST,
        types.DELETE_DOCS_TEMPLATE_SUCCESS,
        types.DELETE_DOCS_TEMPLATE_FAILURE,
    ],
    promise: api => api({
        url: `/api/v1/modules/document-templates/document/delete/${documentId}`,
        method: 'DELETE'
    })
});

export const getDocsTemplateDetails = (documentId) => ({
    types: [
        types.GET_DOCS_TEMPLATE_DETAILS_REQUEST,
        types.GET_DOCS_TEMPLATE_DETAILS_SUCCESS,
        types.GET_DOCS_TEMPLATE_DETAILS_FAILURE,
    ],
    promise: api => api({
        url: `/api/v1/modules/document-templates/document/${documentId}`,
        method: 'GET',
    })
});

export const createOrderDocument = (orderId, documentId, data) => ({
    types: [
        types.CREATE_ORDER_DOCUMENT_REQUEST,
        types.CREATE_ORDER_DOCUMENT_SUCCESS,
        types.CREATE_ORDER_DOCUMENT_FAILURE,
    ],
    promise: api => api({
        url: `/api/v1/orders/${orderId}/document/${documentId}`,
        method: 'POST',
        body: data
    })
});

export const deleteOrderDocument = (orderDocumentId) => ({
    types: [
        types.DELETE_ORDER_DOCUMENT_REQUEST,
        types.DELETE_ORDER_DOCUMENT_SUCCESS,
        types.DELETE_ORDER_DOCUMENT_FAILURE,
    ],
    promise: api => api({
        url: `/api/v1/orders/document/${orderDocumentId}`,
        method: 'DELETE',
    })
});
